import { createSlice } from '@reduxjs/toolkit';
import apiClient from '../../api/api_client';

export const defaultJackpotSlice = {
    rolling_jackpots: [],
    loading: false,
    loaded: false,
};

// REDUCERS

const getJackpotReducer = (state, action) => {
    return {
        rolling_jackpots: action.payload.rolling_jackpots,
        loading: false,
        loaded: true,
    };
};

const setLoadingReducer = (state, { payload: { loading = true } = {} }) => {
    return {
        ...state,
        loading,
        loaded: !!state.loading,
    };
};

export const jackpotSlice = createSlice({
    name: 'jackpot',
    initialState: defaultJackpotSlice,
    reducers: {
        getJackpots: getJackpotReducer,
        setLoading: setLoadingReducer,
    },
});

//ACTUAL ACTIONS
// a place to make the actions more complex if necessary

const getJackpots = async (dispatch, payload) => {
    dispatch(jackpotSlice.actions.setLoading());
    try {
        const result = await apiClient.getJackpot();
        dispatch(jackpotSlice.actions.getJackpots(result));
    } catch (e) {
        dispatch(jackpotSlice.actions.setLoading({ loading: false }));
    }
};

//actions that get exported to the views
export const jackpotActions = dispatch => {
    return {
        getJackpots: payload => getJackpots(dispatch, payload),
    };
};
